export const ADMISSION_FORM_FLOW_ADMISSION = 'admission';
export const ADMISSION_FORM_FLOW_PRESET = 'preset';
export const ADMISSION_FORM_TYPE_PASS = 'pass';
export const ADMISSION_FORM_MODE_CREATE = 'create';
export const ADMISSION_FORM_MODE_EDIT = 'edit';
export const SECTION_BASIC_INFO = 'basicInfo';
export const SECTION_DISTRIBUTION = 'distribution';
export const SECTION_ADD_ONS = 'addOns';
export const SECTION_ADVANCED = 'advanced';
export const SECTION_FORM_FIELDS = 'formFields';
export const SECTION_APPEARANCE = 'appearance';
export const SECTION_VAT_RATE = 'vatRate';
export const SECTION_REGULATION = 'regulation';

export const SECTION_ORDER = [
  SECTION_BASIC_INFO,
  SECTION_REGULATION,
  SECTION_DISTRIBUTION,
  SECTION_ADD_ONS,
  SECTION_ADVANCED,
  SECTION_FORM_FIELDS,
  SECTION_APPEARANCE,
  SECTION_VAT_RATE,
] as const;

export const ADMISSION_FORM_TEST_ID = 'admission-form';
